// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"-bjFW","title":"_1WCx7","anchor":"_2p4Mf","icon":"_20zgb"};